import { Component, signal } from '@angular/core';
import { SetupWizardBreadcrumbs } from '../setup-wizard-breadcrumbs/setup-wizard-breadcrumbs';
import { ActivatedRoute } from '@angular/router';
import { Subscription } from 'rxjs';
import { NzIconModule } from 'ng-zorro-antd/icon';
import { CommonModule } from '@angular/common';
import { SetupWizardClientEditor } from './setup-wizard-client-editor/setup-wizard-client-editor';
import { SetupWizardState } from '@mira-avant/mtlibs';
import { SetupWizardUserEditor } from './setup-wizard-user-editor/setup-wizard-user-editor';
import { SetupWizardLocationEditor } from './setup-wizard-location-editor/setup-wizard-location-editor';
import { SetupWizardCourseEditor } from './setup-wizard-course-editor/setup-wizard-course-editor';
import { SetupWizardUnitEditor } from './setup-wizard-unit-editor/setup-wizard-unit-editor';
import { SetupWizardLessonEditor } from './setup-wizard-lesson-editor/setup-wizard-lesson-editor';
import { SetupWizardActivityEditor } from './setup-wizard-activity-editor/setup-wizard-activity-editor';
import { SetupWizardContentEditor } from './setup-wizard-content-editor/setup-wizard-content-editor';
import { NzSpinModule } from 'ng-zorro-antd/spin';
import { NavigationService } from '../../../../../services/navigation.service';
import { SetupWizardSectionEditor } from './setup-wizard-section-editor/setup-wizard-section-editor';

// If there's more than this number of filter options for any filter column
// disable filtering as it is too slow
export const MAX_FILTER_OPTIONS_ALLOWED = 100;

@Component({
	selector: 'app-setup-wizard-edit-steps',
	imports: [
		CommonModule,
		SetupWizardBreadcrumbs,
		NzIconModule,
		SetupWizardClientEditor,
		SetupWizardUserEditor,
		SetupWizardLocationEditor,
		SetupWizardCourseEditor,
		SetupWizardUnitEditor,
		SetupWizardLessonEditor,
		SetupWizardActivityEditor,
		SetupWizardContentEditor,
		NzSpinModule,
		SetupWizardSectionEditor,
	],
	standalone: true,
	templateUrl: './setup-wizard-edit-steps.html',
	styleUrl: './setup-wizard-edit-steps.scss',
})
export class SetupWizardEditSteps {
	private sub?: Subscription;
	public state = signal<SetupWizardState | undefined>(undefined);
	public SetupWizardState = SetupWizardState;

	constructor(
		private route: ActivatedRoute,
		public nav: NavigationService
	) {
		this.sub = this.route.params.subscribe(params => {
			this.state.set(params['state']);
		});
	}

	ngOnDestroy() {
		this.sub?.unsubscribe();
	}
}
